export default {
	ACCESS_CONTROL: 'companies/:company_id/access-control/',
  AGENT: 'agent/'
}
